import React from "react";
import {
  Edit,
  Create,
  NumberInput,
  FunctionField,
  Toolbar,
  SimpleForm,
  SaveButton,
  Button,
  Link,
  Query,
  DateField,
  DateInput
} from "react-admin";

import moment from "moment";
import { head, prop } from "ramda";

import { parse } from "query-string";
import MotorCycle from "@material-ui/icons/Motorcycle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const RentalPriceEditTitle = object => {
  return (
    <span>
      {" Edit Rental Price for "} &quot;{`${object.record.model.model_name}`}
      &quot;
    </span>
  );
};

const RentalPriceToolBar = (props, classes, className) => (
  <Toolbar {...props}>
    <SaveButton />
    <Button
      component={Link}
      to={{
        pathname: `/vehicle_models/${props.record.model.id}/5`
      }}
      label={`Back to ${props.record.model.model_name}`}
    >
      <MotorCycle />
    </Button>
  </Toolbar>
);

const validateFormEdit = values => {
  const errors = {};
  if (!values.price) {
    errors.price = ["Price is required"];
  }
  if (values.price === 0) {
    errors.price = ["Price should be greater than 0"];
  }
  return errors;
};

const validateFormCreate = values => {
  const errors = {};

  if (moment(values.last_date).isAfter(moment(values.start_date))) {
    errors.start_date = [
      `Start date must be later than date for last price added - ${values.last_date}`
    ];
  }
  if (!values.price_1_3) {
    errors.price_1_3 = ["Price is required"];
  }
  if (values.price_1_3 === 0) {
    errors.price_1_3 = ["Price should be greater than 0"];
  }
  if (!values.price_4_6) {
    errors.price_4_6 = ["Price is required"];
  }
  if (values.price_4_6 === 0) {
    errors.price_4_6 = ["Price should be greater than 0"];
  }
  if (!values.price_7_13) {
    errors.price_7_13 = ["Price is required"];
  }
  if (values.price_7_13 === 0) {
    errors.price_7_13 = ["Price should be greater than 0"];
  }
  if (!values.price_14_1000) {
    errors.price_14_1000 = ["Price is required"];
  }
  if (values.price_14_1000 === 0) {
    errors.price_14_1000 = ["Price should be greater than 0"];
  }
  return errors;
};

export const RentalPriceEdit = ({ ...props }) => {
  const modelId = parse(props.location.search).vm;
  const redirect = `/vehicle_models/${modelId}/5`;
  return (
    <Edit title={<RentalPriceEditTitle />} {...props}>
      <SimpleForm
        resource="rental_prices"
        redirect={redirect}
        validate={validateFormEdit}
        toolbar={<RentalPriceToolBar props={{ ...props }} />}
      >
        <FunctionField
          label="Days Interval"
          render={p => {
            return (
              <span>
                {p.days_interval_1} to {p.days_interval_2} days
              </span>
            );
          }}
        />
        <DateField label="Start Date" locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="start_date" />
        <NumberInput label="Price (EUR)" source="price" />
      </SimpleForm>
    </Edit>
  );
};

const RentalPriceCreateTitle = object => {
  const modelName = object.record.vmt;
  return (
    <span>
      {" Create Rental Prices for "} &quot;{modelName}
      &quot;
    </span>
  );
};

const CancelButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `/vehicle_models/${object.record.vm}/5`
      }}
      label="Cancel"
    >
      <ArrowBackIcon />
    </Button>
  );
};

const RentalPriceToolBarC = (props, classes, className) => {
  const modelId = parse(props.props.location.search).vm;
  return (
    <Toolbar {...props}>
      <SaveButton redirect={`/vehicle_models/${modelId}/5`} />
      <CancelButton modelId />
    </Toolbar>
  );
};

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const RentalPriceCreate = ({ ...props }) => {
  const modelId = parse(props.location.search).vm;
  const redirect = `/vehicle_models/${modelId}/5`;

  const payload = {
    pagination: { page: 1, perPage: 1000 },
    filter: {
      prices_vehicle_model_id: modelId
    },
    sort: { field: "id", order: "ASC" }
  };

  return (
    <Create title={<RentalPriceCreateTitle />} {...props}>
      <SimpleForm
        resource="rental_prices"
        redirect={redirect}
        validate={validateFormCreate}
        toolbar={<RentalPriceToolBarC props={{ ...props }} />}
      >
        <Query type="GET_LIST" resource="Xprices" payload={payload}>
          {({ data, loading, error }) => {
            if (loading) {
              return <p>Loading...</p>;
            }
            if (error) {
              return <p>Error loading resource.</p>;
            }
            const lastDate = moment(
              prop("start_date", head(data)) || moment()
            ).format("YYYY-MM-DD");
            return (
              <React.Fragment>
                <DateInput locales="es-Es" options={{ timeZone: 'UTC' }}
                  style={{ display: "none" }}
                  source="last_date"
                  defaultValue={lastDate}
                  readOnly={true}
                />
              </React.Fragment>
            );
          }}
        </Query>

        <DateInput label="Start Date" source="start_date" locales="es-Es" options={{ timeZone: 'UTC' }}/>
        <NumberInput label="Price (EUR) 1 to 3 Days" source="price_1_3" />
        <NumberInput label="Price (EUR) 4 to 6 Days" source="price_4_6" />
        <NumberInput label="Price (EUR) 7 to 13 Days" source="price_7_13" />
        <NumberInput
          label="Price (EUR) 14 to 1000 Days"
          source="price_14_1000"
        />
      </SimpleForm>
    </Create>
  );
};



// WEBPACK FOOTER //
// ./src/resources/rentalPrices.js